import React, {useState} from 'react';
import {Button, ConfigProvider, DatePicker, Form, Input, Modal, Select, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {bytesToFileSizeString} from "../../../../../Common/util/FileUtil";
import {EditOutlined} from "@ant-design/icons";
import {TB_STORAGE_DIR} from "./data/TB_STORAGE_DIR";
import {TB_STORAGE_MGR} from "./data/StorageWizMgrData";
import dayjs from 'dayjs';
import 'dayjs/locale/ko'; // 또는 사용하고자 하는 로케일에 맞게 변경
import locale from 'antd/locale/ko_KR';
import SelectArchive from "../../common/component/SelectArchive";

dayjs.locale('ko');
const { RangePicker } = DatePicker;
const ArchiveFolderMgr: React.FC = () => {
    const {token: {colorBgContainer},} = theme.useToken();

    const queryClient = useQueryClient();
    const queryKey: QueryKey = [`ArchiveFolderMgr`];

    const serviceCode: string = process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);


    let requestParam:any = null;

    const {data, isFetching,refetch} = useCommonUseQuery<TB_STORAGE_DIR[]>(
        queryKey,
        () => procAdminService<TB_STORAGE_DIR[]>("post", `${serviceCode}ADS16`, requestParam));

    const [showModal, setShowModal] = useState<boolean>(false);
    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);


    const [storageMgrEntity, setStorageMgrEntity] = useState<TB_STORAGE_MGR>({
        storageName: '',
        mainPath: '',
        limitCnt: 0,
        limitFileSize: 0,
    });
    const [dirKey, setDirKey] = useState<string>('');
    const [dirYear, setDirYear] = useState<string>('');
    const [dirMonth, setDirMonth] = useState<string>('');

    const [storagePath, setStoragePath] = useState<string>('');
    const [limitFileCnt, setLimitFileCnt] = useState<number>(0);
    const [curFileCnt, setCurFileCnt] = useState<number>(0);
    const [curFileSize, setCurFileSize] = useState<number>(0);
    const [limitFileSize, setLimitFileSize] = useState<number>(0);
    const [status, setStatus] = useState<string>('');
    const [archivePath, setArchivePath] = useState<string>('');
    const [archiveYn, setArchiveYn] = useState<string>('');
    const [calcFilesize, setCalcFilesize] = useState<string>("GB");

    const [selectArchive, setSelectArchive] = useState<string>('');

    const [selectedRange, setSelectedRange] = useState<dayjs.Dayjs[]>([]);


    const handleDateChange = (dates: any, dateStrings: [string, string]) => {
        // dates 배열에서 dayjs 객체로 변환된 날짜 값을 추출합니다.
        setSelectedRange(dates.map((date: string) => dayjs(date)));
    };



    function onSearch()
    {
        let startDate:string = '';
        let endDate:string = '';

        if (selectedRange.length === 2) {
            startDate = dayjs(selectedRange[0]).locale('ko').format('YYYY-MM');
            endDate = dayjs(selectedRange[1]).locale('ko').format('YYYY-MM');
        }

        requestParam = {
            startDate:startDate,
            endDate:endDate,
            selectArchive:selectArchive
        };

        refetch();
    }

    const columns: ColumnsType<TB_STORAGE_DIR> = [
        {
            title: '스토리지명',
            dataIndex: 'storageMgrEntity',
            key: 'storageMgrEntity',
            render: (text, record:TB_STORAGE_DIR) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {record.storageMgrEntity.storageName}
                </div>

        },
        {
            title: 'Key',
            dataIndex: 'dirKey',
            key: 'dirKey',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '생성연도',
            dataIndex: 'dirYear',
            key: 'dirYear',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '생성월',
            dataIndex: 'dirMonth',
            key: 'dirMonth',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '메인경로',
            dataIndex: 'storagePath',
            key: 'storagePath',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '폴더당파일개수',
            dataIndex: 'limitFileCnt',
            key: 'limitFileCnt',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '폴더당파일용량',
            dataIndex: 'limitFileSize',
            key: 'limitFileSize',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {bytesToFileSizeString(parseInt(text)) }
                </div>

        },
        {
            title: '현재파일개수',
            dataIndex: 'curFileCnt',
            key: 'curFileCnt',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text }
                </div>

        },
        {
            title: '현재용량',
            dataIndex: 'curFileSize',
            key: 'curFileSize',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {bytesToFileSizeString(parseInt(text)) }
                </div>

        },
        {
            title: '폴더상태',
            dataIndex: 'status',
            key: 'status',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text === "r" ? "읽기전용" : "읽기/쓰기"}
                </div>

        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_STORAGE_DIR) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => {openModifyModal(record)}}>수정</Button>
                </div>

        },



    ];

    function openModifyModal(recode:TB_STORAGE_DIR)
    {
        const isGB:boolean = bytesToFileSizeString(recode.limitFileSize).includes("GB");
        setCalcFilesize(isGB ? "GB" : "MB");
        setStorageMgrEntity(recode.storageMgrEntity);
        setDirKey(recode.dirKey);
        setDirYear(recode.dirYear)
        setDirMonth(recode.dirMonth);
        setStoragePath(recode.storagePath);
        setLimitFileSize( isGB ? recode.limitFileSize /1024 /1024 /1024 : recode.limitFileSize /1024 /1024);
        setLimitFileCnt( recode.limitFileCnt);
        setCurFileCnt( recode.curFileCnt );
        setCurFileSize( recode.curFileSize );
        setStatus( recode.status );
        setArchivePath( recode.archivePath );
        setArchiveYn( recode.archiveYn);

        setShowModal(true);
    }

    function onSaveArchive()
    {

        const requestParam:TB_STORAGE_DIR = {
            storageMgrEntity:storageMgrEntity,
            dirKey:dirKey,
            dirYear:dirYear,
            dirMonth:dirMonth,
            storagePath:storagePath,
            limitFileCnt:limitFileCnt,
            curFileCnt:curFileCnt,
            curFileSize:curFileSize,
            limitFileSize:calcFilesize === "MB" ?  limitFileSize *1024 *1024 : limitFileSize *1024 *1024 *1024,
            status:status,
            archivePath:archivePath,
            archiveYn:archiveYn,
        }


        Modal.confirm({
            title: `아카이빙 폴더 설정을 저장하시겠습니까?`,
            content: "",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU10`, requestBody:requestParam }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                        setShowModal(false);
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });
    }

    const fields = [
        { name: ['storageName'], value: storageMgrEntity?.storageName },
        { name: ['dirKey'], value: dirKey },
        { name: ['dirMonth'], value: dirMonth },
        { name: ['storagePath'], value: storagePath },
        { name: ['limitFileSize'], value: limitFileSize },
        { name: ['curFileCnt'], value: curFileCnt },
        { name: ['curFileSize'], value: curFileSize },
        { name: ['limitFileCnt'], value: limitFileCnt },
        { name: ['status'], value: status },
        { name: ['archivePath'], value: archivePath },
        { name: ['archiveYn'], value: archiveYn },
        { name: ['dirYear'], value: dirYear },


    ];



    return (
        <>
            <nav style={{
                margin:'0px 0px 14px 0px',
                padding:'9px 8px 9px 0px',
                height: '50px',
                display:'flex',
                justifyContent: "space-between",
                alignItems:'center',
                borderRadius: "8px", // 라운드 처리 추가
                border: '1px solid #dadada',
                background: colorBgContainer,
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{
                        padding: '9px 5px',
                        display:'flex',
                    }}>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ConfigProvider locale={locale}>
                        <RangePicker picker="month" allowClear={false} onChange={handleDateChange} />
                    </ConfigProvider>
                    <SelectArchive onChangeValue={(value)=>{setSelectArchive(value)}}/>
                    <Button style={{marginRight:"10px"}} type={"primary"} onClick={onSearch}>조회</Button>
                </div>

            </nav>
        <Table columns={columns}
            dataSource={data}
            rowKey="dirKey"
            loading={isFetching}
        />

            <Modal
                open={showModal}
                title="아카이브폴더수정"
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    fields={fields}
                    name="saveArchive"
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveArchive}
                >

                    <Form.Item
                        label={"저장경로"}
                        name="storagePath"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="저장경로"
                            value={storagePath}
                            onChange={(e)=>setStoragePath(e.target.value)}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"폴더당파일개수"}
                        name="limitFileCnt"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="폴더당파일개수"
                            value={limitFileCnt}
                            onChange={(e)=>setLimitFileCnt(parseInt(e.target.value))}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"폴더당파일크기"}
                        name="limitFileSize"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Select
                            defaultValue="GB"
                            style={{ width: 80 }}
                            onChange={(value)=>{{ setCalcFilesize(value) }}}
                            options={[
                                { value: 'MB', label: 'MB' },
                                { value: 'GB', label: 'GB' },
                            ]}
                        />
                        <Input
                            style={{width : "276px", marginLeft: "6px"}}
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="폴더당파일크기"
                            value={limitFileSize}
                            onChange={(e)=>setLimitFileSize( parseInt(e.target.value))}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"폴더상태"}
                        name="status"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Select
                            defaultValue={status}
                            style={{ width: 130 }}
                            onChange={(value)=>{{ setStatus(value) }}}
                            options={[
                                { value: 'r', label: '읽기전용' },
                                { value: 'w', label: '읽기/쓰기' },
                            ]}
                        />

                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ArchiveFolderMgr;
